const e = "styles-module__row___uk-95", _ = "styles-module__room___3JjyW", t = "styles-module__price___8kCy-", o = {
  "payment-selector": "styles-module__payment-selector___CGkzy",
  "payment-details": "styles-module__payment-details___QYf7-",
  "expanded-header": "styles-module__expanded-header___nPnIk",
  "expanded-header-title": "styles-module__expanded-header-title___RegRl",
  "booking-summary-content": "styles-module__booking-summary-content___iXoru",
  "cart-item": "styles-module__cart-item___etCNT",
  row: e,
  room: _,
  price: t,
  "booking-summary": "styles-module__booking-summary___18yct",
  "payment-method": "styles-module__payment-method___7k474"
};
export {
  o as default,
  t as price,
  _ as room,
  e as row
};
